import { useState, useEffect } from "react";
import cn from "classnames";
import i from "@styles/icons.module.scss";
import s from "./Textarea.module.scss";

const Textarea = ({
  icon,
  label,
  className,
  value = "",
  errors,
  withoutMessage,
  errorWithoutMessage,
  ...props
}) => {
  const [inputValue, setInputValue] = useState(value);
  const onInput = (e) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const classes = cn(
    s.textarea,
    className,
    !label && s.noLabel,
    icon && s.withIcon,
    inputValue && s.hasValue,
    (errors || errorWithoutMessage) && s.error,
    withoutMessage && s.withoutMessage,
    className,
  );

  return (
    <div className={classes}>
      {label && <label>{label}</label>}
      <textarea
        name=""
        id=""
        rows="5"
        {...props}
        value={inputValue}
        onInput={onInput}
      />
      {icon && <icon className={i[icon]}/>}
      {errors && <div className={s.message}>{errors}</div>}
    </div>
  );
};

export default Textarea;
